import { useEffect, useState } from "react";
import { Plus, Trash2, CheckCircle2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

export default function AcademicYears() {
  const [items, setItems] = useState([]);
  const [label, setLabel] = useState("");
  const [error, setError] = useState("");

  const load = () => api.get("/academic-years").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/academic-years", { label, active: false });
      setLabel("");
      load();
    } catch (err) { setError(formatApiError(err)); }
  };

  const activate = async (id) => {
    await api.post(`/academic-years/${id}/activate`);
    load();
  };

  const del = async (id) => {
    if (!window.confirm("Supprimer cette année ?")) return;
    await api.delete(`/academic-years/${id}`);
    load();
  };

  return (
    <div data-testid="academic-years-page">
      <div className="eyebrow eyebrow-dark">Configuration</div>
      <h1 className="mt-2 text-3xl font-bold text-unisic-blue">Années académiques</h1>
      <p className="mt-2 text-slate-600 text-sm">L'année active est utilisée automatiquement pour tous les nouveaux dépôts.</p>
      <span className="divider-gold mt-3" />

      <form onSubmit={add} className="mt-8 flex gap-3 flex-wrap" data-testid="year-add-form">
        <input
          value={label}
          onChange={(e) => setLabel(e.target.value)}
          placeholder="Ex : 2026-2027"
          className="border border-slate-300 px-3 py-2.5 rounded-sm text-sm min-w-[200px]"
          data-testid="input-year"
        />
        <button className="btn-primary text-sm" type="submit" data-testid="btn-add-year">
          <Plus className="w-4 h-4" /> Ajouter
        </button>
        {error && <div className="text-sm text-unisic-red">{error}</div>}
      </form>

      <div className="mt-6 paper-card overflow-hidden">
        <table className="unisic-table w-full">
          <thead className="bg-slate-50 border-b border-slate-200">
            <tr>
              <th className="px-4 py-3">Année</th>
              <th className="px-4 py-3">Statut</th>
              <th className="px-4 py-3 text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {items.map((y) => (
              <tr key={y.id} className="hover:bg-slate-50" data-testid={`year-row-${y.id}`}>
                <td className="px-4 py-3 font-medium">{y.label}</td>
                <td className="px-4 py-3">
                  {y.active ? (
                    <span className="status-pill bg-green-50 text-green-700 border-green-100"><CheckCircle2 className="w-3 h-3" /> Active</span>
                  ) : (
                    <span className="text-slate-500 text-xs">Inactive</span>
                  )}
                </td>
                <td className="px-4 py-3 text-right">
                  <div className="flex gap-2 justify-end">
                    {!y.active && (
                      <button onClick={() => activate(y.id)} className="text-xs text-unisic-blue hover:underline" data-testid={`btn-activate-${y.id}`}>
                        Activer
                      </button>
                    )}
                    <button onClick={() => del(y.id)} className="text-slate-400 hover:text-unisic-red" data-testid={`btn-del-year-${y.id}`}>
                      <Trash2 className="w-3.5 h-3.5" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
